module.exports = __webpack_public_path__ + "img/sms.b68df864.png";